import { render, staticRenderFns } from "./ExpoTour.vue?vue&type=template&id=0c98aacc&"
import script from "./ExpoTour.vue?vue&type=script&lang=js&"
export * from "./ExpoTour.vue?vue&type=script&lang=js&"
import style0 from "./ExpoTour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c98aacc')) {
      api.createRecord('0c98aacc', component.options)
    } else {
      api.reload('0c98aacc', component.options)
    }
    module.hot.accept("./ExpoTour.vue?vue&type=template&id=0c98aacc&", function () {
      api.rerender('0c98aacc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExpoTour.vue"
export default component.exports